import {
	Box,
	Button,
	Center,
	Paper,
	PasswordInput,
	Stack,
	Text,
	TextInput,
	ThemeIcon,
	Title
} from "@mantine/core";
import { useState, type FormEvent } from "react";
import { useAuth } from "@hooks/useAuth.tsx";
import { ContainerComponent } from "@components/default/ContainerComponent.tsx";
import {
	IconLock,
	IconLogin,
	IconLogout,
	IconShieldCheck,
	IconUser
} from "@tabler/icons-react";

export function LoginPage() {
	const { login, isAuthenticated, user, logout } = useAuth();
	const [username, setUsername] = useState<string>('');
	const [password, setPassword] = useState<string>('');
	const [userLoading, setUserLoading] = useState<boolean>(false);

	const handleLogin = (e: FormEvent) => {
		setUserLoading(true);
		e.preventDefault();
		login({ username, password }).finally(() => {
			setUserLoading(false);
		});
	};

	return (
		<ContainerComponent>
			<Center style={{ minHeight: 'calc(100vh - 180px)', width: '100%' }}>
				<Paper withBorder shadow="md" p="xl" radius="lg" style={{ width: '100%', maxWidth: 440 }}>
					{!isAuthenticated ? (
						<Box component="form" onSubmit={handleLogin}>
							<Stack gap="md">
								<Center>
									<ThemeIcon size={56} radius="xl" variant="light" color="blue">
										<IconShieldCheck size={32} />
									</ThemeIcon>
								</Center>

								<Box ta="center">
									<Title order={2} fw={700}>
										Entrar no Sistema
									</Title>
									<Text size="sm" c="dimmed" mt={4}>
										Insira suas credenciais para acessar sua conta
									</Text>
								</Box>

								<TextInput
									label="Usuário"
									placeholder="Seu nome de usuário"
									leftSection={<IconUser size={18} />}
									value={username}
									onChange={(e) => setUsername(e.currentTarget.value)}
									required
									autoFocus
								/>

								<PasswordInput
									label="Senha"
									placeholder="Sua senha"
									leftSection={<IconLock size={18} />}
									value={password}
									onChange={(e) => setPassword(e.currentTarget.value)}
									required
								/>

								<Button
									type="submit"
									fullWidth
									size="md"
									mt="xs"
									loading={userLoading}
									leftSection={<IconLogin size={18} />}
								>
									Entrar
								</Button>
							</Stack>
						</Box>
					) : (
						<Stack gap="md" align="center" ta="center">
							<ThemeIcon size={64} radius="xl" variant="light" color="info">
								<IconUser size={36} />
							</ThemeIcon>

							<div>
								<Title order={3} fw={700}>
									Bem-vindo, {user?.userName}!
								</Title>
								<Text c="dimmed" size="sm" mt={4}>
									Você já está conectado ao sistema.
								</Text>
							</div>

							<Button
								variant="outline"
								color="red"
								onClick={logout}
								fullWidth
								size="md"
								leftSection={<IconLogout size={18} />}
							>
								Sair da conta
							</Button>
						</Stack>
					)}
				</Paper>
			</Center>
		</ContainerComponent>
	);
}